/* eslint-disable */

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div style="width: 75%; margin: 0 auto">
          <div style="position: relative; user-select: none">
            <!-- Background network diagram image -->
            <img
              src="https://ip-learn.b-cdn.net/simulations/ddos-attack-source-identification/graphic.png"
              style="width: 100%; display: block; border-radius: 8px"
              alt=""
              draggable="false"
            />

            <!-- ── Clickable server overlays ── -->
            <div
              v-for="server in servers"
              :key="server.key"
              :style="server.overlayStyle"
              style="position: absolute; cursor: pointer; border-radius: 14px; transition: background 0.15s"
              @click="openServer(server.key)"
              @mouseenter="hoveredServer = server.key"
              @mouseleave="hoveredServer = null"
              :class="hoveredServer === server.key ? 'server-overlay-hover' : 'server-overlay'"
            />

            <!-- ── Answer dropdowns ── -->

            <!-- Dropdown 1: Compromised host -->
            <div style="position: absolute; top: 53%; left: 50%; width: 51%; display: flex; align-items: center; gap: 16px">
              <p
                style="
                  color: #fff;
                  font-weight: 700;
                  font-size: 0.92em;
                  margin: 0;
                  line-height: 1.3;
                  width: 38%;
                  flex-shrink: 0;
                  white-space: normal;
                  word-break: break-word;
                "
              >
                Select the compromised host:
              </p>
              <div style="flex: 1" :style="vSelectWrapStyle(hostAnswer, correctHost)">
                <v-select v-model="hostAnswer" :options="hostOptions" placeholder="Select" @input="onAnswer" />
              </div>
            </div>

            <!-- Dropdown 2: Compromised executable -->
            <div style="position: absolute; top: 63%; left: 50%; width: 51%; display: flex; align-items: center; gap: 16px">
              <p
                style="
                  color: #fff;
                  font-weight: 700;
                  font-size: 0.92em;
                  margin: 0;
                  line-height: 1.3;
                  width: 38%;
                  flex-shrink: 0;
                  white-space: normal;
                  word-break: break-word;
                "
              >
                Select the compromised executable:
              </p>
              <div style="flex: 1" :style="vSelectWrapStyle(execAnswer, correctExec)">
                <v-select v-model="execAnswer" :options="execOptions" placeholder="Select" @input="onAnswer" />
              </div>
            </div>

            <!-- Dropdown 3: Correct remediation -->
            <div style="position: absolute; top: 73%; left: 50%; width: 51%; display: flex; align-items: center; gap: 16px">
              <p
                style="
                  color: #fff;
                  font-weight: 700;
                  font-size: 0.92em;
                  margin: 0;
                  line-height: 1.3;
                  width: 38%;
                  flex-shrink: 0;
                  white-space: normal;
                  word-break: break-word;
                "
              >
                Select the correct remediation:
              </p>
              <div style="flex: 1" :style="vSelectWrapStyle(remediationAnswer, correctRemediation)">
                <v-select v-model="remediationAnswer" :options="remediationOptions" placeholder="Select" @input="onAnswer" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── Server logs popup ── -->
    <movable-popup
      refVal="serverLogsPopup"
      :title="activeServerData ? activeServerData.name + ' Logs — ' + activeServerData.ip : ''"
      width="72vw"
      :active="serverPopupActive"
      v-on:close="serverPopupActive = false"
      padding="0"
    >
      <template v-slot:content>
        <div v-if="activeServerData">
          <vs-table :data="activeServerData.rows" style="font-family: 'Courier New', Courier, monospace; font-size: 0.85em">
            <template slot="thead">
              <vs-th>Proto</vs-th>
              <vs-th>Local Address</vs-th>
              <vs-th>Foreign Address</vs-th>
              <vs-th>State</vs-th>
              <vs-th>PID</vs-th>
              <vs-th>Process</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="(row, i) in activeServerData.rows" :key="i">
                <vs-td
                  ><span :style="row.proto === 'UDP' ? 'color:#F6AD55;font-weight:600' : 'color:#63B3ED;font-weight:600'">{{
                    row.proto
                  }}</span></vs-td
                >
                <vs-td>{{ row.local }}</vs-td>
                <vs-td>{{ row.foreign }}</vs-td>
                <vs-td
                  ><span :style="row.state === 'ESTABLISHED' ? 'color:#28C76F;font-weight:600' : 'color:#EA5455;'">{{
                    row.state
                  }}</span></vs-td
                >
                <vs-td>{{ row.pid }}</vs-td>
                <vs-td
                  ><span v-if="row.process" style="color: #f687b3; font-weight: 600">{{ row.process }}</span></vs-td
                >
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </template>
    </movable-popup>
  </div>
</template>

<script>
/* eslint-disable */
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../../components/popup/MovablePopup';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      // Answer state
      hostAnswer: '',
      execAnswer: '',
      remediationAnswer: '',

      correctHost: '192.168.10.5',
      correctExec: 'mysql.exe',
      correctRemediation: 'Disable web browsing from the server domain.',

      hostOptions: ['192.168.10.5', '192.168.10.6', '172.16.25.20', '172.16.50.10', '172.16.25.60', '172.16.25.50'],
      execOptions: ['mysql.exe', 'weblogic.exe', 'sftp.exe', 'dns.exe', 'mozilla.exe'],
      remediationOptions: [
        'Reimage the host workstation 2.',
        'Bypass the proxy server for all HTTP requests.',
        'Block all HTTP requests to the target IP address.',
        'Disable web browsing from the server domain.',
      ],

      // Popup state
      serverPopupActive: false,
      activeServer: null,
      hoveredServer: null,

      // Server configs — overlayStyle positions match the server buttons in the background image
      // Adjust top/left/width/height percentages to align with your graphic
      servers: [
        {
          key: 'dns',
          name: 'DNS Server',
          ip: '172.16.25.20',
          overlayStyle: 'top: 20.5%; left: 1.9%; width: 26%; height: 16.3%;',
          rows: [
            { proto: 'TCP', local: '0.0.0.0:22', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '1000', process: '' },
            { proto: 'TCP', local: '0.0.0.0:23', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '1200', process: '' },
            { proto: 'TCP', local: '0.0.0.0:443', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '1400', process: '' },
            { proto: 'TCP', local: '0.0.0.0:80', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '2122', process: '' },
            { proto: 'TCP', local: '127.0.0.1', foreign: '172.16.25.20:3389', state: 'ESTABLISHED', pid: '2480', process: 'mysql.exe' },
            { proto: 'UDP', local: '127.0.0.1:53', foreign: '192.168.10.5', state: 'ESTABLISHED', pid: '2722', process: 'dns.exe' },
          ],
        },
        {
          key: 'proxy',
          name: 'Proxy Server',
          ip: '172.16.50.10',
          overlayStyle: 'top: 40%; left: 1.9%; width: 26%; height: 16.7%;',
          rows: [
            { proto: 'TCP', local: '0.0.0.0:22', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '1000', process: '' },
            { proto: 'TCP', local: '0.0.0.0:23', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '1200', process: '' },
            { proto: 'TCP', local: '0.0.0.0:443', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '1400', process: '' },
            { proto: 'TCP', local: '0.0.0.0:80', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '2122', process: '' },
            { proto: 'TCP', local: '127.0.0.1:8100', foreign: '43.104.133.19:https', state: 'ESTABLISHED', pid: '2699', process: '' },
            { proto: 'TCP', local: '127.0.0.1:8100', foreign: '16.34.111.1:https', state: 'ESTABLISHED', pid: '2722', process: '' },
            { proto: 'TCP', local: '127.0.0.1:8100', foreign: '203.4.3.7:https', state: 'ESTABLISHED', pid: '2782', process: '' },
            { proto: 'TCP', local: '127.0.0.1:8100', foreign: '43.104.133.91:https', state: 'ESTABLISHED', pid: '2900', process: '' },
            { proto: 'UDP', local: '127.0.0.1:9211', foreign: '172.16.25.50:53', state: 'ESTABLISHED', pid: '9145', process: '' },
          ],
        },
        {
          key: 'app',
          name: 'Application Server',
          ip: '172.16.25.60',
          overlayStyle: 'top: 60%; left: 1.9%; width: 26%; height: 16.7%;',
          rows: [
            { proto: 'TCP', local: '0.0.0.0:22', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '1000', process: '' },
            { proto: 'TCP', local: '0.0.0.0:23', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '1322', process: '' },
            { proto: 'TCP', local: '0.0.0.0:443', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '1577', process: '' },
            { proto: 'TCP', local: '0.0.0.0:80', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '2189', process: '' },
            { proto: 'TCP', local: '127.0.0.1', foreign: '172.16.25.20:3306', state: 'ESTABLISHED', pid: '2440', process: 'mysql.exe' },
            { proto: 'TCP', local: '127.0.0.1:7001', foreign: '192.168.10.5', state: 'ESTABLISHED', pid: '6200', process: 'weblogic.exe' },
            { proto: 'TCP', local: '127.0.0.1:7002', foreign: '192.168.10.6', state: 'ESTABLISHED', pid: '6234', process: 'weblogic.exe' },
            { proto: 'UDP', local: '127.0.0.1', foreign: '172.16.25.50:53', state: 'ESTABLISHED', pid: '6844', process: '' },
          ],
        },
        {
          key: 'db',
          name: 'Database Server',
          ip: '172.16.25.50',
          overlayStyle: 'top: 80.35%; left: 1.9%; width: 26%; height: 16.3%;',
          rows: [
            { proto: 'TCP', local: '0.0.0.0:22', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '1000', process: '' },
            { proto: 'TCP', local: '0.0.0.0:23', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '1200', process: '' },
            { proto: 'TCP', local: '0.0.0.0:443', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '1480', process: '' },
            { proto: 'TCP', local: '0.0.0.0:80', foreign: '0.0.0.0:0', state: 'LISTENING', pid: '2122', process: '' },
            { proto: 'TCP', local: '192.168.10.20:3306', foreign: '192.168.10.6', state: 'ESTABLISHED', pid: '2480', process: '' },
            {
              proto: 'TCP',
              local: '127.0.0.1:8100',
              foreign: '172.16.50.10:https',
              state: 'ESTABLISHED',
              pid: '2722',
              process: 'mozilla.exe',
            },
            { proto: 'UDP', local: '127.0.0.1:9211', foreign: '172.16.25.50:53', state: 'ESTABLISHED', pid: '9145', process: '' },
          ],
        },
      ],
    };
  },

  computed: {
    activeServerData() {
      if (!this.activeServer) return null;
      return this.servers.find((s) => s.key === this.activeServer) || null;
    },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
  },

  methods: {
    openServer(key) {
      this.activeServer = key;
      this.serverPopupActive = true;
    },

    vSelectWrapStyle(value, correct) {
      if (!value) return 'border-radius: 4px;';
      if (value === correct) return 'border-radius: 4px; box-shadow: 0 0 0 2px #28C76F;';
      return 'border-radius: 4px; box-shadow: 0 0 0 2px #EA5455;';
    },

    onAnswer() {
      let score = 0;
      if (this.hostAnswer === this.correctHost) score++;
      if (this.execAnswer === this.correctExec) score++;
      if (this.remediationAnswer === this.correctRemediation) score++;
      this.$emit('simulation_update_score', score);
      if (score >= 3) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },
  },

  components: { vSelect, MovablePopup },

  props: {
    data: { type: Object, required: true },
  },
};
</script>

<style scoped>
.server-overlay {
  background: transparent;
}
.server-overlay-hover {
  background: rgba(0, 83, 255, 0.12);
  outline: 2px solid rgba(0, 83, 255, 0.4);
}
</style>

<style>
.vs-table--tbody-tr:not(:last-child) td.vs-table--td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}
</style>
